/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import Loader from '@Pure/Loader'

const { app, qwest } = window;

export default class Form extends Component
{
	state =
	{
		loading: false
	};

	handleSubmit = (e) =>
	{
		var component = this, props = this.props, property;

		e.preventDefault();

		var form_data = new FormData(), data = props.data;

		if (component.state.loading === true) return;

		Object.keys(data).forEach(function (property)
		{
			if (typeof data[property] !== 'string') return;

			if (data[property] === undefined) return;

			form_data.append(property, data[property] instanceof String ?
				data[property].trim() : data[property]);
		});

	// Object
		Object.keys(data).forEach(function (property)
		{
			if (typeof data[property] === 'string') return;

			if (data[property] === undefined || data[property] === '') return;

			if (data[property] instanceof Array)
			{
				data[property].forEach(function (data)
				{
					if (!data.file && !data.pdf && !data.url)
					{
						if (data instanceof Object)
						{
							appendProperties(data, property);
						}
					}
				});
			}
			else if (data[property] instanceof Object)
			{
				appendProperties(data[property], property);
			}
			else
			{
				form_data.append(property, data[property]);
			}
		});

	// file from DB
		Object.keys(data).forEach(function (property)
		{
			if (typeof data[property] === 'string') return;

			if (data[property] === undefined || data[property] === '') return;

			if (data[property] instanceof Array)
			{
				data[property].forEach(function (file_preview)
				{
					if (file_preview.url) // from DB
					{
						form_data.append(property, JSON.stringify(file_preview));
					}
				});
			}
		});

	// new file
		Object.keys(data).forEach(function (property)
		{
			if (typeof data[property] === 'string') return;

			if (data[property] === undefined || data[property] === '') return;

			if (data[property] instanceof Array)
			{
				data[property].forEach(function (file_preview)
				{
					if (file_preview.file)
					{
						form_data.append(property, file_preview.file);
					}
					else if (file_preview.pdf)
					{
						form_data.append(property, file_preview.pdf);
					}
				});
			}
		});

		function appendProperties (object, name)
		{
			Object.keys(object).forEach(function (field)
			{
				if (data[field] && data[field] instanceof Object)
				{
					appendProperties(object[field], name + '[' + field + ']');
				}
				else
				{
					form_data.append(name + '[' + field + ']', object[field]);
				}
			});
		}

		if (props.onSubmit instanceof Function)
		{
			props.onSubmit();
		}

		component.setState(
		{
			loading: true
		});

		qwest.post(props.action, form_data)
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			if (props.onValidate)
			{
				props.onValidate(response);
			}
			else if (response.pathname)
			{
				component.props.history.push(response.pathname);
			}
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			app.ajaxRedirectLogin(response);

			component.setState(
			{
				loading: false
			});

			try
			{
				if (typeof props.onError === 'function') props.onError(response);
			}
			catch (error)
			{
				console.error(error);
			}
		});
	}

	render ()
	{
		var component = this, props = this.props;
		var label, element, type, warning, error, loader, submit;

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader" bemit={ ['white', 'bg-secondary'] }
					text={ props.loader_txt } />
			);
		}

		if (props.hide_button !== true)
		{
			submit =
			(
				<button type="submit" className="c-form__submit">
					{ props.submit_label || 'envoyer' }
					{ loader }
				</button>
			);
		}

		var output =
		(
			<form className={ 'c-form' + (props.className ? ' ' + props.className : '') }
				method="POST" action={ props.action } onSubmit={ component.handleSubmit }>

				{ component.props.children }

				{ submit }

			</form>
		);

		return output;
	}
}